export enum FeatureFlags {
  ENTITLEMENTS_USE_PRISM = 'portal-configure-entitlements-use-prism',
  TEMPLATES = 'portal-rollout-templates',
  APIHUB_WELCOME_BAR_MESSAGE_INDEX = 'api-hub-welcome-bar-message-index',
  CKEDITOR_HTML_SUPPORT = 'portal-rollout-ck-editor-html-support',
  MARKDOWN_EDITING_SUPPORT = 'portal-permanent-markdown-editing-support',
  TEST_BETA_LABEL = 'portal-rollout-test-beta-label',
}

export type Flags = { [key in FeatureFlags]: boolean }